'use client';

import { Box, Container, Typography } from '@mui/material';
import BookingBooker from '@/components/website/booking/BookingBooker';
import WebsiteInteriorScrollLayout from './WebsiteInteriorScrollLayout';

export default function BookOnlinePage() {
  return (
    <WebsiteInteriorScrollLayout>
      <Container
        maxWidth="md"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          px: { xs: 2, sm: 3, md: 4 },
          pt: { xs: 4, md: 6 },
          pb: { xs: 6, md: 10 },
        }}
      >
        <Typography
          component="h1"
          variant="h3"
          className="tk-brown"
          align="center"
          sx={{ flexShrink: 0, mb: { xs: 3, md: 4 }, fontWeight: 500 }}
        >
          Book A Design Consultation Online
        </Typography>
        <Box component="section" aria-label="Book an appointment">
          <BookingBooker />
        </Box>
      </Container>
    </WebsiteInteriorScrollLayout>
  );
}
